import React from 'react';
import { BootLogo } from 'screens/BootScreen';
import styles from 'components/shared/NavigationBar/NavigationBar.module.scss';

export const BootNavigationBar = () => {
  return (
    <header className={styles.container}>
      <div className={styles.outerBin}>
        <div className={styles.bin}>
          <BootLogo />
        </div>
      </div>
    </header>
  );
};
